<script>
export default {};
</script>


// WEBPACK FOOTER //
// resources/js/frontend/components/Application.vue